<div class="layout-column custom-panel full-width full-height">

  <!--Header-->
  <div class="layout-row layout-align-start-center padding-5 header">
    <span class="br-body-2 font-weight-600 primary-100" translate>Import Drivers</span>
    <span class="flex"></span>
    <bringoz-button type="tertiary" (onClick)="onCancel()">
      <bringoz-icon iconName="close"></bringoz-icon>
    </bringoz-button>
  </div>

  <hr class="main-divider">

  <!--BODY-->
  <div class="flex layout-column">
    <app-visit-plan-external-agents-resource-holders-list
      class="flex"
      [visitPlanId]="data.visitPlanId"
      [visitScheduleId]="data.visitScheduleId"
      (onSelectionChange)="onSelectionChange($event)">
    </app-visit-plan-external-agents-resource-holders-list>
  </div>

  <div class="layout-row layout-align-start-center padding-5 footer-border-top">
    <bringoz-button [type]="'tertiary'"
                    [theme]="'primary'"
                    (onClick)="onCancel()">
      <span>{{ 'Cancel' | translate }}</span>
    </bringoz-button>

    <span class="flex"></span>

    <bringoz-button [theme]="'secondary'"
                    (onClick)="onSubmit()">
      <span>{{ 'Import' | translate }}</span>
    </bringoz-button>
  </div>

</div>
